var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('circle',{attrs:{"cx":"256","cy":"256","r":"256","fill":"#fefefe"}}),_c('path',{attrs:{"fill":"#d4213d","d":"M512 256a256 256 0 0 1-512 0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }